export default __webpack_public_path__ + "static/media/monieTree.e4e24ea7.png";